import type { InternalAxiosRequestConfig } from 'axios'

/**
 * Let the browser label a file upload itself.
 *
 * The API client defaults every request to `application/json`. Axios turns a
 * `FormData` body sent with that header into JSON, so the file never arrives
 * (`file: Field required`). Removing the header for a `FormData` body lets the
 * browser send `multipart/form-data` with its boundary, as every upload needs.
 */
export function letBrowserLabelUploads(config: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    config.headers?.delete?.('Content-Type')
  }
  return config
}
